import React from "react";

import SearchableOptionsMenu from "@ats/src/components/shared/SearchableOptionsMenu";
import { SourceOption } from "@ats/src/views/jobApplications/components/SourceFilterSelect";

interface Props {
  options: SourceOption[];
  activeValues: string[];
  disabledValues: string[];
  onSelect: (value: string) => void;
}

const AddSourceFilterMenu: React.FunctionComponent<Props> = ({
  options,
  activeValues,
  disabledValues,
  onSelect,
}) => {
  const menuOptions = options
    .filter((option) => !activeValues.includes(option.value))
    .map((option) => ({
      key: option.value,
      label: option.label,
      isDisabled: disabledValues.includes(option.value),
    }));

  if (menuOptions.length === 0) return null;

  return (
    <SearchableOptionsMenu
      text="Add source"
      icon="plus"
      searchPlaceholder="Search sources"
      options={menuOptions}
      onSelect={onSelect}
      disabledTooltip="No candidates in this hiring stage match this filter."
    />
  );
};

export default AddSourceFilterMenu;
